import React from 'react';
import Grid from "@mui/material/Grid";
import { DateTime } from 'luxon';
import { startOfMonth, endOfMonth } from "../../utils/dateFunctions";
import MonthSelector from "../../shared/MonthSelector";
import BillsEditable from './Tables/BillsEditable';
import { userInfo } from "../../../adalConfig";

const AllInvoicesPage = (props) => {
    const [selectedMonth, setSelectedMonth] = React.useState(DateTime.now());
    const [startDate, setStartDate] = React.useState(startOfMonth(new Date()));
    const [endDate, setEndDate] = React.useState(endOfMonth(new Date()));
    const [reload, setReload] = React.useState(false);
    const [user] = React.useState(userInfo());
    const userName = user?.userName || "";

    const reloadFunc = React.useCallback(() => {
        setReload((current) => !current);
    }, []);

    const handleMonthChange = React.useCallback((nextMonth) => {
        if (!nextMonth?.toJSDate) {
            return;
        }

        const nextMonthDate = nextMonth.toJSDate();
        setSelectedMonth(nextMonth);
        setStartDate(startOfMonth(nextMonthDate));
        setEndDate(endOfMonth(nextMonthDate));
    }, []);

    return (
        <React.Fragment>
            <Grid container spacing={2} mb={1}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <MonthSelector
                        title="Month"
                        date={selectedMonth}
                        setDate={handleMonthChange}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={3.5}>
                <Grid item xs={12}>
                    <BillsEditable
                        workflowId="6"
                        userName={userName}
                        startDate={startDate}
                        endDate={endDate}
                        enableDateFilter
                        title="All Invoices"
                        access={props.access}
                        reloadFunc={reloadFunc}
                        reload={reload}
                        dashboard
                        summary
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    );
};

export default AllInvoicesPage;